import React , {useEffect, useState , useContext , useRef} from "react";
// import Navbar from "../components/navbar";
import Header from "../components/Header";
// import call from '../assets/call.png' ;
// import Navbar from '../components/Navbar.jsx' ;
// import Header from "../components/Header.jsx";
import star from "../assets/Group-29637.png" ;
// import line from "../assets/Line 2.png" ;
import FeelingCard from "../components/FeelingCard.jsx";
import Feelingdata from "../components/FeelinigCardContent.jsx";
import DestinationCard from "../components/DestinationCard.jsx";
import destination from "../components/DestinationData.jsx";
// import Pre from "../assets/previous.png" ;
// import Next from "../assets/next.png" ;
import USP from "../components/USP.jsx";
import Udata from "../components/USPData.jsx";
import PartnerSlide from "../components/PartnerSlide.jsx";
import Footer from "../components/Footer.jsx";
import BrandDeal from "../components/BrandDeal.jsx";
import Brand from "../components/BrandMaking.jsx";
 import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faArrowRight , faArrowLeft} from '@fortawesome/free-solid-svg-icons';
import { ReactComponent as Destination} from '../assets/destination.svg' ;
import { ReactComponent as Cruisline} from '../assets/cruiselines.svg' ;
import { ReactComponent as Booking} from '../assets/book.svg' ;
import Navbar from "../components/navbar.jsx";
import ScrolltoTop from "../components/ScrolltoTop.jsx";
import AutoShowModal from "../components/AutoShowModal.jsx";
import { CurrencyContext } from "../components/CurrencyContext";
// import Thumbnail1 from "../assets/disney-fantasy-aquaduck-from-above-int2cruises.webp"
// import Thumbnail2 from "../assets/first-time-cruises-int2cruises-blog.jpg";
// import Thumbnail3 from "../assets/eastmed_destination-int2cruises.jpg";
// import Thumbnail4 from "../assets/Iceland_valcano_burfell_Int2Cruises.jpg";
import Thumbnail1 from "../assets/4.jpg"
import Thumbnail2 from "../assets/2.jpg";
import Thumbnail3 from "../assets/1.jpg";
import Thumbnail4 from "../assets/3.jpg";
import BlogCard from "../components/BlogCard.jsx";
import UTMHandler from "../components/UTMHandler.jsx";
import { Helmet } from "react-helmet";

const blogPosts = [
  {
    title: "Six ways to find the cheapest cruise deals",
    excerpt: "Timing is everything. If you are looking to book a popular cruise itinerary during ....",
    image: Thumbnail1,
    link: "/six-ways-to-find-the-cheapest-cruise-deals",
  },
  {
    title: "5 Things First-Time Cruisers Must Know Before Booking Their Cruise Holiday",
    excerpt: "Before you dive in and book your dream vacation at sea, here ...",
    image: Thumbnail2,
    link: "/5-things-first-time-cruisers-must-know-before-booking-their-cruise-holiday",
  },
  {
    title: "Top 4 Upcoming European Summer Cruises in 2025",
    excerpt: "From sun-soaked Mediterranean towns to the mystical fjords of the north...",
    image: Thumbnail3,
    link: "/top-4-european-summer-cruises-coming-in-2025",
  },
  {
    title: "Top 5 Northern Europe Cruises in 2025",
    excerpt: "A Northern Europe cruise is not just a holiday. It's an entrance to centuries of maritime history, glacial landscapes, and ....",
    image: Thumbnail4,
    link: "/top-5-northern-europe-cruises-in-2025",
  },
];


function Home() {



//  Destination

   const currency = useContext(CurrencyContext);

  
  const [index, setIndex] = useState(0);
  
  const [cardsPerView, setCardsPerView] = useState(3);

const [isPaused, setIsPaused] = useState(false);
    const containerRef = useRef(null);
    const touchStartX = useRef(0);
    const touchEndX = useRef(0);

  // Array of only the selected deals
  const selectedDeals = [destination[0], destination[1], destination[2] , destination[3], destination[4], destination[5], destination[6], destination[7]];
    const maxIndex = selectedDeals.length - cardsPerView;

  useEffect(() => {
    const updateCardsPerView = () => {
      setCardsPerView(window.innerWidth < 768 ? 1 : 3);
    };
    updateCardsPerView();
    window.addEventListener('resize', updateCardsPerView);
    return () => window.removeEventListener('resize', updateCardsPerView);
  }, []);

  // Auto-slide every 3 seconds
    useEffect(() => {

       if (isPaused) return;

      const interval = setInterval(() => {

        setIndex(prev => (prev >= maxIndex ? 0 : prev + 1));
      }, 5000);
      return () => clearInterval(interval);
    }, [maxIndex, isPaused]);
  
     // Swipe handlers
  const handleTouchStart = (e) => {
    touchStartX.current = e.touches[0].clientX;
  };

  const handleTouchMove = (e) => {
    touchEndX.current = e.touches[0].clientX;
  };

   const handleTouchEnd = () => {
    const diff = touchStartX.current - touchEndX.current;
    if (diff > 50) {
      // Swipe left
      setIndex(prev => (prev >= maxIndex ? 0 : prev + 1));
    } else if (diff < -50) {
      // Swipe right
      setIndex(prev => (prev <= 0 ? maxIndex : prev - 1));
    }
  };



  // const handlePrev = () => {
  //   setIndex((prev) => (prev <= 0 ? maxIndex : prev - 1));
  // };
  
  // const handleNext = () => {
  //   setIndex((prev) => (prev >= maxIndex ? 0 : prev + 1));
  // };

  const visibleDeals = selectedDeals.slice(index, index + cardsPerView);



  //  Brand Deal
  const [bdindex, bdsetIndex] = useState(0);
  
  const [bdcardsPerView, bdsetCardsPerView] = useState(3);

     const bdcontainerRef = useRef(null);
    const bdtouchStartX = useRef(0);
    const bdtouchEndX = useRef(0);

  // Array of only the selected deals
  const bdselectedDeals = [BrandDeal[0], BrandDeal[1], BrandDeal[2] , BrandDeal[3], BrandDeal[4], BrandDeal[5], BrandDeal[6], BrandDeal[7], BrandDeal[8], BrandDeal[9], BrandDeal[10], BrandDeal[11]];
  const bdmaxIndex = bdselectedDeals.length - bdcardsPerView;


  useEffect(() => {
    const bdupdateCardsPerView = () => {
      bdsetCardsPerView(window.innerWidth < 768 ? 1 : 3);
    };
    bdupdateCardsPerView();
    window.addEventListener('resize', bdupdateCardsPerView);
    return () => window.removeEventListener('resize', bdupdateCardsPerView);
  }, []);

 // Auto-slide every 3 seconds
    useEffect(() => {
      const interval = setInterval(() => {
        bdsetIndex(prev => (prev >= bdmaxIndex ? 0 : prev + 1));
      }, 5000);
      return () => clearInterval(interval);
    }, [bdmaxIndex]);
  
     // Swipe handlers
  const bdhandleTouchStart = (e) => {
    bdtouchStartX.current = e.touches[0].clientX;
  };

  const bdhandleTouchMove = (e) => {
    bdtouchEndX.current = e.touches[0].clientX;
  };

   const bdhandleTouchEnd = () => {
    const diff = bdtouchStartX.current - bdtouchEndX.current;
    if (diff > 50) {
      // Swipe left
      bdsetIndex(prev => (prev >= bdmaxIndex ? 0 : prev + 1));
    } else if (diff < -50) {
      // Swipe right
      bdsetIndex(prev => (prev <= 0 ? bdmaxIndex : prev - 1));
    }
  };

  // const bdhandlePrev = () => {
  //   bdsetIndex((prev) => (prev <= 0 ? bdmaxIndex : prev - 1));
  // };
  
  // const bdhandleNext = () => {
  //   bdsetIndex((prev) => (prev >= bdmaxIndex ? 0 : prev + 1));
  // };

  const bdvisibleDeals = bdselectedDeals.slice(bdindex, bdindex + bdcardsPerView);



  //  Cruise Feeling

  const [findex, fsetIndex] = useState(0);
  
  const [fcardsPerView, fsetCardsPerView] = useState(3);


    const fcontainerRef = useRef(null);
    const ftouchStartX = useRef(0);
    const ftouchEndX = useRef(0);

  // Array of only the selected deals
  const fselectedDeals = [Feelingdata[0], Feelingdata[1], Feelingdata[2] , Feelingdata[3]];
  const fmaxIndex = fselectedDeals.length - fcardsPerView;


  useEffect(() => {
    const fupdateCardsPerView = () => {
      fsetCardsPerView(window.innerWidth < 768 ? 1 : 3);
    };
    fupdateCardsPerView();
    window.addEventListener('resize', fupdateCardsPerView);
    return () => window.removeEventListener('resize', fupdateCardsPerView);
  }, []);

// Auto-slide every 3 seconds
    useEffect(() => {
      const interval = setInterval(() => {
        fsetIndex(prev => (prev >= fmaxIndex ? 0 : prev + 1));
      }, 5000);
      return () => clearInterval(interval);
    }, [fmaxIndex]);
  
     // Swipe handlers
  const fhandleTouchStart = (e) => {
    ftouchStartX.current = e.touches[0].clientX;
  };

  const fhandleTouchMove = (e) => {
    ftouchEndX.current = e.touches[0].clientX;
  };

  const handleMouseEnter = () => {
  setIsPaused(true);
};

const handleMouseLeave = () => {
  setIsPaused(false);
};

const handleClick = () => {
  setIsPaused(true);
  // optionally resume after 10s
  setTimeout(() => setIsPaused(false), 7000);
};

   const fhandleTouchEnd = () => {
    const diff = ftouchStartX.current - ftouchEndX.current;
    if (diff > 50) {
      // Swipe left
      fsetIndex(prev => (prev >= fmaxIndex ? 0 : prev + 1));
    } else if (diff < -50) {
      // Swipe right
      fsetIndex(prev => (prev <= 0 ? fmaxIndex : prev - 1));
    }
  };
  // const fhandlePrev = () => {
  //   fsetIndex((prev) => (prev <= 0 ? fmaxIndex : prev - 1));
  // };
  
  // const fhandleNext = () => {
  //   fsetIndex((prev) => (prev >= fmaxIndex ? 0 : prev + 1));
  // };

  const fvisibleDeals = fselectedDeals.slice(findex, findex + fcardsPerView);


  return (
    <>
    <UTMHandler/>

    <Helmet>
      <title>Book Cruises Online | Int2Cruises – Trusted Cruise Experts in Asia</title>
      <meta name="description" content="Int2Cruises brings global cruise culture to Asia. Enjoy the best price guarantee, expert guidance, and easy booking for international cruises & more." />
    </Helmet>
    
    <div className="home-navbar">
       <Navbar/>
     </div>
    
    <Header/>

     <div className="Section-3">
                 
         <h2>Pick Your Perfect Destinations</h2>

         <div className="carousel-wrapper" >

       <div className="button-style">
        <button onClick={() => setIndex(prev => (prev <= 0 ? maxIndex : prev - 1))} style={{backgroundColor:'transparent', border:'none'}} >
           {/* <img src={Pre} alt="Previos button" /> */}
           <FontAwesomeIcon icon={ faArrowLeft} style={{color:"#164D55" , fontSize:'1.8rem' }} className="backward-icon" />
        </button>

        <button onClick={() => setIndex(prev => (prev >= maxIndex ? 0 : prev + 1))} style={{backgroundColor:'transparent', border:'none'}}  >
            {/* <img src={Next} alt= "Next button" /> */}
            <FontAwesomeIcon icon={ faArrowRight} style={{color:"#164D55" , fontSize:'1.8rem'}} className="forward-icon" />
        </button>

        </div>

        <div className="trip "  ref={containerRef}
          onTouchStart={handleTouchStart}
          onTouchMove={handleTouchMove}
          onTouchEnd={handleTouchEnd} 
          onMouseEnter={handleMouseEnter}
          onMouseLeave={handleMouseLeave}
          style={{ display: 'flex', gap: '18vh' , transition: 'transform 0.5s ease-in-out' , marginTop:'5vh'}}>
           {visibleDeals.map((deal, i) => (
          <a
            key={i}
            href={deal.links[currency.currencyCode]}
            target="_self"
            rel="noopener noreferrer"
            style={{ flex: '1', textDecoration: 'none' }}
           className="trip-card-link"
           onClick={handleClick}

          >
            <DestinationCard img={deal.img} name={deal.name} />
          </a>
        ))}
        </div>
        
        
        </div>

      </div>

      <div className="Section-4">
                 
         <h2>Brands Making Waves</h2>

         <div className="carousel-wrapper" >

       <div className="button-style">
        <button onClick={() => bdsetIndex(prev => (prev <= 0 ? bdmaxIndex : prev - 1))} style={{backgroundColor:'transparent', border:'none'}}  >
           <FontAwesomeIcon icon={ faArrowLeft} style={{color:"#164D55" , fontSize:'1.8rem'}} className="backward-icon" />
          
           {/* <img src={Pre} alt="Previos button" /> */}
        </button>

        <button onClick={() => bdsetIndex(prev => (prev >= bdmaxIndex ? 0 : prev + 1))} style={{backgroundColor:'transparent', border:'none'}}  >
            <FontAwesomeIcon icon={ faArrowRight} style={{color:"#164D55" , fontSize:'1.8rem'}} className="forward-icon" />
            {/* <img src={Next} alt= "Next button" /> */}
        </button>

        </div>

        <div className="trip" ref={bdcontainerRef}
        onTouchStart={bdhandleTouchStart}
          onTouchMove={bdhandleTouchMove}
          onTouchEnd={bdhandleTouchEnd}
         style={{ display: 'flex', gap: '18vh' , transition: 'transform 0.5s ease-in-out' , marginTop:'3vh'}}>
           {bdvisibleDeals.map((deal, i) => (
          <a
            key={i}
            href={deal.links[currency.currencyCode]}
            target="_self"
            rel="noopener noreferrer"
            style={{ flex: '1', textDecoration: 'none' }}
          >
            <Brand img={deal.img} offer={deal.offer} brand={deal.brand} />
          </a>
        ))}
        </div>
        
        
        </div>

      </div>



               <div className="section-1">

                <div className="heading-1">
                  <p>Your Cruise Is Just A 
                  Click Away</p>
                  
                </div>

                <div className="steps">

                <div>
                  <img src={star} alt="int2cruises logo "/>
                  <Destination style={{height:'12vh'}} className="usp-icon"/>
                  <p className="step-heading">Step - 1</p>
              <p className="step-subheading">Pick Your Destination</p>
                  <p className="step-content">Select the destination around the world that calls your spirit of adventure.</p>
                </div>

               

                <div>
                   <img src={star} alt="int2cruises logo "/>
                   <Cruisline  style={{height:'12vh'}}/>
                  <p className="step-heading">Step - 2</p>
                  <p className="step-subheading">Choose A Cruise Line</p>
                  <p className="step-content">Explore our handpicked options and find the perfect cruise for your travel style.</p>
                </div>

                {/* <img src={line} alt="vertical line" /> */}

                <div>
                  <img src={star} alt="int2cruises logo "/>
                  <Booking style={{height:'12vh'}}/>
                  <p className="step-heading">Step - 3</p>
                  <p className="step-subheading">Book A Cruise</p>
                  <p className="step-content">Lock in your Vacay by just entering your names and date of birth.</p>
                </div>

                </div>


                <div className="Section-2">

                <div className="heading">
                    <h2>Cruise Is A Feeling</h2>
                </div>

<div className="carousel-wrapper" >

       <div className="button-style">
        <button onClick={() => fsetIndex(prev => (prev <= 0 ? fmaxIndex : prev - 1))} style={{backgroundColor:'transparent', border:'none'}} >
           <FontAwesomeIcon icon={ faArrowLeft} style={{color:"#fff" , fontSize:'1.8rem'}} className="backward-icon" />

        </button>

        <button onClick={() => fsetIndex(prev => (prev >= fmaxIndex ? 0 : prev + 1))}  style={{backgroundColor:'transparent', border:'none'}}  >
                                <FontAwesomeIcon icon={ faArrowRight} style={{color:"#fff" , fontSize:'1.8rem'}} className="forward-icon" />

        </button>

        </div>

        <div className="trip"
        ref={fcontainerRef}
        onTouchStart={fhandleTouchStart}
          onTouchMove={fhandleTouchMove}
          onTouchEnd={fhandleTouchEnd}>
           {fvisibleDeals.map((deal, i) => (
          <a
            key={i}
            href={deal.links[currency.currencyCode]}
            target="_self"
            rel="noopener noreferrer"
            style={{ flex: '1', textDecoration: 'none' }}
          >
            <FeelingCard img={deal.img} heading={deal.heading} content={deal.content} />
          </a>
        ))}
        </div>
        
        
        </div>
        </div>

               </div>


               
                {/* <div className="card1-align">

                  <FeelingCard img={Feelingdata[0].img} heading={Feelingdata[0].heading} content={Feelingdata[0].content} />
                  <FeelingCard img={Feelingdata[1].img} heading={Feelingdata[1].heading} content={Feelingdata[1].content} />
                  <FeelingCard img={Feelingdata[2].img} heading={Feelingdata[2].heading} content={Feelingdata[2].content} />

                </div> */}



               


               <div className="Section-6">
               <h2>
               What Sets Us Apart
               </h2>

                <div className="usp-align">

                <USP img={Udata[0].img} heading={Udata[0].heading} content={Udata[0].content}/>
                <USP img={Udata[1].img} heading={Udata[1].heading} content={Udata[1].content}/>
                <USP img={Udata[2].img} heading={Udata[2].heading} content={Udata[2].content}/>
                <USP img={Udata[3].img} heading={Udata[3].heading} content={Udata[3].content}/>
              
               </div>

               </div>


               <div className="Section-5">
                <h2>Our Partners</h2>

               
                <PartnerSlide/>
                


      </div>
        <section className="homepage-blog-section">
        <h2>Featured Blog</h2>
        <div className="blog-grid2">
          {blogPosts.map((post, index) => (
            <BlogCard key={index} post={post} />
          ))}
        </div>
      </section>

<ScrolltoTop/>
<AutoShowModal/>
<Footer/>
     
    </>
  );
}

export default Home;
